// SIWS CUSTOM: State Hats product page — state-hats-picker.js
// "Add State" flow: state dropdown + qty (multiples of 12) + Add State button.
// Builds an order table; each row is a separate cart line item with _State property.
// Duplicate state selection merges qty into existing row.

(function () {
  var SIWS_HATS_STEP       = 12;
  var SIWS_HATS_MIN        = 12;
  var SIWS_HATS_UNIT_PRICE = 20.00;

  document.addEventListener('DOMContentLoaded', function () {
    var form       = document.getElementById('siws-hats-form');
    if (!form) return;

    var stateSelect  = document.getElementById('siws-hats-state');
    var qtyInput     = document.getElementById('siws-hats-qty');
    var addBtn       = document.getElementById('siws-hats-add-btn');
    var inputErrorEl = document.getElementById('siws-hats-input-error');
    var tableEl      = document.getElementById('siws-hats-order-table');
    var atcErrorEl   = document.getElementById('siws-hats-error');
    var atcBtn       = document.getElementById('siws-hats-atc-btn');
    var variantId    = parseInt(form.dataset.variantId, 10);

    // SIWS CUSTOM: Order state — array of {state, qty} objects.
    var orderRows = [];

    // ── Snap qty to nearest multiple of 12, min 12 when non-zero ──
    function snapQty(raw) {
      var n = parseInt(raw, 10);
      if (!n || n <= 0) return 0;
      var snapped = Math.round(n / SIWS_HATS_STEP) * SIWS_HATS_STEP;
      return Math.max(snapped, SIWS_HATS_MIN);
    }

    // Ghost zero: blur restores placeholder and snaps value.
    qtyInput.addEventListener('blur', function () {
      var snapped = snapQty(qtyInput.value);
      if (snapped === 0) {
        qtyInput.value       = '';
        qtyInput.placeholder = '0';
      } else {
        qtyInput.value = snapped;
      }
    });

    // ── Add State ──
    addBtn.addEventListener('click', function () {
      var state = stateSelect.value;
      var qty   = snapQty(qtyInput.value);

      if (!state) {
        showInputError('Please select a state.');
        stateSelect.focus();
        return;
      }
      if (qty < SIWS_HATS_MIN) {
        showInputError('Minimum is ' + SIWS_HATS_MIN + ' hats (multiples of ' + SIWS_HATS_STEP + ').');
        qtyInput.focus();
        return;
      }

      clearInputError();

      // SIWS CUSTOM: Merge into existing row if state already added.
      var existing = orderRows.filter(function (r) { return r.state === state; })[0];
      if (existing) {
        existing.qty += qty;
      } else {
        orderRows.push({ state: state, qty: qty });
      }

      // Reset inputs
      stateSelect.value    = '';
      qtyInput.value       = '';
      qtyInput.placeholder = '0';

      render();
    });

    // ── Render ──
    function render() {
      renderTable();
      updateAtcButton();
      clearAtcError();
    }

    function renderTable() {
      if (orderRows.length === 0) {
        tableEl.hidden = true;
        return;
      }

      var totalQty  = orderRows.reduce(function (s, r) { return s + r.qty; }, 0);
      var totalCost = (totalQty * SIWS_HATS_UNIT_PRICE).toFixed(2);

      var rowsHtml = orderRows.map(function (row, i) {
        var lineCost = (row.qty * SIWS_HATS_UNIT_PRICE).toFixed(2);
        return '<tr>' +
          '<td>' + escHtml(row.state) + '</td>' +
          '<td class="screwdriver-summary__qty-cell">' + row.qty + '</td>' +
          '<td class="screwdriver-summary__qty-cell">$' + SIWS_HATS_UNIT_PRICE.toFixed(2) + '</td>' +
          '<td class="screwdriver-summary__qty-cell">$' + lineCost + '</td>' +
          '<td style="padding-left:0.6rem;">' +
            '<button type="button" class="siws-hats-remove-btn" data-remove-index="' + i + '" aria-label="Remove ' + escHtml(row.state) + '">&times;</button>' +
          '</td>' +
        '</tr>';
      }).join('');

      var headerStyle = 'text-align:right;padding:0 0 0.6rem;font-size:1.1rem;color:rgba(var(--color-foreground),0.45);font-weight:600;';
      var headerStyleLeft = 'text-align:left;padding:0 0 0.6rem;font-size:1.1rem;color:rgba(var(--color-foreground),0.45);font-weight:600;';

      tableEl.innerHTML =
        '<h4 class="screwdriver-summary__title">Adding to Cart</h4>' +
        '<table class="screwdriver-summary__table">' +
          '<thead><tr>' +
            '<th style="' + headerStyleLeft + '">State</th>' +
            '<th style="' + headerStyle + '">Qty</th>' +
            '<th style="' + headerStyle + '">Price</th>' +
            '<th style="' + headerStyle + '">Total</th>' +
            '<th></th>' +
          '</tr></thead>' +
          '<tbody>' + rowsHtml + '</tbody>' +
          '<tfoot><tr class="screwdriver-summary__total-row">' +
            '<td colspan="3">Total</td>' +
            '<td class="screwdriver-summary__qty-cell">$' + totalCost + '</td>' +
            '<td></td>' +
          '</tr></tfoot>' +
        '</table>';

      tableEl.hidden = false;

      // Bind remove buttons after rendering
      tableEl.querySelectorAll('.siws-hats-remove-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.removeIndex, 10);
          orderRows.splice(idx, 1);
          render();
        });
      });
    }

    function updateAtcButton() {
      if (orderRows.length === 0) {
        atcBtn.disabled    = true;
        atcBtn.textContent = 'Add to Cart';
        return;
      }
      var totalQty  = orderRows.reduce(function (s, r) { return s + r.qty; }, 0);
      var totalCost = (totalQty * SIWS_HATS_UNIT_PRICE).toFixed(2);
      atcBtn.disabled    = false;
      atcBtn.textContent = 'Add ' + totalQty + ' hat' + (totalQty === 1 ? '' : 's') + ' to Cart \u2014 $' + totalCost;
    }

    // ── ATC ──
    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled || orderRows.length === 0) return;

      // Validate all rows are multiples of SIWS_HATS_STEP
      for (var i = 0; i < orderRows.length; i++) {
        if (orderRows[i].qty % SIWS_HATS_STEP !== 0 || orderRows[i].qty < SIWS_HATS_MIN) {
          showAtcError('All quantities must be multiples of ' + SIWS_HATS_STEP + ' (minimum ' + SIWS_HATS_MIN + ').');
          return;
        }
      }

      var items = orderRows.map(function (row) {
        return {
          id:         variantId,
          quantity:   row.qty,
          properties: { 'State': row.state },
        };
      });

      var originalText   = atcBtn.textContent;
      atcBtn.disabled    = true;
      atcBtn.textContent = 'Adding\u2026';
      clearAtcError();

      // SIWS CUSTOM (2026-05-12): augment body with Section Rendering API hints
      // so the Dawn cart drawer/notification can re-render itself from the response.
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items: items,
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body),
      })
        .then(async function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          // SIWS CUSTOM (2026-05-12): swap redirect for Dawn cart drawer/notification.
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-state-hats', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            // SIWS CUSTOM (2026-05-12): Page-mode — stay on PDP, refresh cart bubble.
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
            // SIWS CUSTOM (2026-05-12): clear picker state so a re-click can't double-add.
            orderRows.length = 0;
            render();
          }
        })
        .catch(function () {
          atcBtn.disabled    = false;
          atcBtn.textContent = originalText;
          showAtcError('Something went wrong \u2014 please try again.');
        });
    });

    // ── Helpers ──
    function showInputError(msg) {
      inputErrorEl.textContent   = msg;
      inputErrorEl.style.display = 'block';
    }
    function clearInputError() {
      inputErrorEl.style.display = 'none';
    }
    function showAtcError(msg) {
      atcErrorEl.textContent   = msg;
      atcErrorEl.style.display = 'block';
    }
    function clearAtcError() {
      atcErrorEl.style.display = 'none';
    }
    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  });
})();
